/* eslint react-hooks/exhaustive-deps: "warn" */

import { useCallback, useState } from 'react';

import cn from 'classnames';

import { Button } from 'ui/atoms/Button/Button';
import type { ButtonType } from 'ui/atoms/Button/Button.types';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';

import { ModalFormBook } from 'features/articles/organisms/ModalFormBook';

import styles from './SalesBanner.module.scss';

type Props = {
  title: string;
  description: string;
  buttonText: string;
  theme?: string;
  onClick?: () => void;
  route?: string;
  buttonType?: ButtonType;
  className?: string;
  tags?: string[];
};

const baseClass = 'gdb-sales-banner';

export const SalesBanner = ({
  title,
  description,
  buttonText,
  theme,
  onClick,
  route,
  buttonType = 'white',
  className,
  tags,
}: Props) => {
  const [showModal, setShowModal] = useState(false);

  const onToggleModal = useCallback(() => setShowModal((s) => !s), []);

  const filteredTags = (tags && tags.filter(Boolean)) || [];

  return (
    <>
      {showModal && <ModalFormBook title="Contact Enterprise Sales" maxWidth={630} onClose={onToggleModal} />}

      <section className={cn(styles[`${baseClass}-wrapper`], className)}>
        <div className={cn(styles[`${baseClass}-container`], theme && styles[`${baseClass}-container--${theme}`])}>
          <div className={styles[`${baseClass}-content`]}>
            <div className={styles[`${baseClass}-text`]}>
              <TitleBlock
                title={title}
                description={description}
                align="left"
                theme="dark"
                className={styles.titleBlock}
              />

              {filteredTags.length > 0 && (
                <div className={styles[`${baseClass}-tags`]}>
                  {filteredTags.map((tag, i) => (
                    <span key={i}>{tag}</span>
                  ))}
                </div>
              )}
            </div>

            <div className={styles[`${baseClass}-button`]}>
              {route ? (
                <Button route={route} type={buttonType}>
                  {buttonText}
                </Button>
              ) : (
                <Button onClick={onClick || onToggleModal} type={buttonType}>
                  {buttonText}
                </Button>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
